export default "__VITE_ASSET__CF1vtWjH__"